var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "so-pin",
    d: "M3.309,21.691a1.056,1.056,0,0,1,0-1.493l8.733-8.733L9.333,8.758l.575-.576a3.257,3.257,0,0,1,4.607,0l2.3-2.3L15.667,4.727,17.394,3,22,7.607,20.273,9.333,19.122,8.182l-2.3,2.3a3.257,3.257,0,0,1,0,4.607l-.576.575-2.708-2.709L4.8,21.691a1.056,1.056,0,0,1-1.493,0Z",
    transform: "translate(-3 -3)",
    fill: "#2772af"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoPin);
export default __webpack_public_path__ + "static/media/so-pin.3213adb4879d24e3da812300c0e04855.svg";
export { ForwardRef as ReactComponent };